import { getAllFacilities } from './getAllFacilities';
import { EFacilityType, type TJsonQuery } from './types';
import { type NonEmptyArray } from './types/common';
import { nonEmptyArrayOr } from './utils/nonEmptyArrayOr';

const URBAN_FACILITY_TYPES: EFacilityType[] = [
  EFacilityType.Conditioner,
  EFacilityType.RoomFurniture,
  EFacilityType.KitchenFurniture,
  EFacilityType.WithoutFurniture,
  EFacilityType.Internet,
  EFacilityType.Fridge,
  EFacilityType.Phone,
  EFacilityType.Dishwasher,
  EFacilityType.TV,
  EFacilityType.Washer,
];

export function getFacilityTypes(jsonQuery: TJsonQuery): NonEmptyArray<EFacilityType> | null {
  const facilities = (getAllFacilities(jsonQuery) || []).filter(f => URBAN_FACILITY_TYPES.includes(f));

  return nonEmptyArrayOr(facilities);
}
